import React from "react";
import { HStack, IconButton } from "@chakra-ui/react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

export default function StarRating({ value = 0, onChange, max = 5, readOnly = false, size = "md" }) {
  const stars = Array.from({ length: max }, (_, i) => i + 1);
  return (
    <HStack spacing={1}>
      {stars.map((n) => {
        const filled = n <= (value || 0);
        const Icon = filled ? AiFillStar : AiOutlineStar;
        return (
          <IconButton
            key={n}
            aria-label={`star-${n}`}
            icon={<Icon />}
            size={size}
            variant="ghost"
            color={filled ? "yellow.400" : "gray.400"}
            onClick={readOnly ? undefined : () => onChange && onChange(n)}
            isDisabled={readOnly}
          />
        );
      })}
    </HStack>
  );
}
